<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}个{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" type="danger" size="small" :disabled="multiple" v-preventReClick @click="handleDelete">
            删除
          </el-button>
          <!-- <el-button type="primary" class="btn primary" @click="handleApprove">审批通过</el-button> -->
          <BatchApproval  ref="BatchApproval" :multipleSelectionList="multipleSelection" :batchApproval="batchApproval" @getData="getData"
            @reset="reset" />

          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange" @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <el-button class="btn primary" type="primary" style="margin-right: 10px"
          @click="showTransfer">自定义设置</el-button>
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <div v-if="tableHaeder.length>0">
        <CustomTable  ref="customTable" :tableData="tableData" @handleSelectionChange="handleSelectionChange" :tableHaeder="tableHaeder" :loading="loading"
        @resetMethod="reset" :tableHeight="tableHeight" @onApproveStatusSuccess="getData" :tableCode="route.name"> 
          <template slot="before">
            <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
            </el-table-column>
          </template>
          <template slot="after">
  
            <el-table-column prop="operation" fixed="right" label="操作" width="110">
              <template slot-scope="scope">
                <el-button v-if="tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick @click="handleUpdate(scope.row)" class="color-blue">查看</el-button>
                <el-button v-if="tableAcl.indexOf('Remove') != -1" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
              </template>
            </el-table-column>
          </template>
        </CustomTable>
      </div>
     <div v-else>
      <el-table ref="multipleTable" border v-loading="loading" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column fixed type="selection" width="55" align="center"></el-table-column>
        <el-table-column prop="createdTime" label="创建时间" width="110">
          <template slot-scope="scope">
            <div>
              {{ parseTime(new Date(scope.row.createdTime), "{y}-{m}-{d}") }}
            </div>
            <div>
              {{ parseTime(new Date(scope.row.createdTime), "{h}:{i}:{s}") }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="supplierName" width="160" label="供应商" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="oldId" width="60" label="类型" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{ Boolean(scope.row.oldId) ? "修改" : "新建" }}
          </template>
        </el-table-column>
        <el-table-column prop="productName" width="180" label="产品名称" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="specName" width="150" label="规格型号" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="stateName" width="100" label="产品状态" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="certApproveStateName" width="100" label="证件状态" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="purchasePrice" width="100" label="采购价" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="productRegistCertName" width="150" label="注册证名称" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="manufacturerName" width="150" label="生产厂家" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="agentName" width="150" label="售后代理商" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{ scope.row.agentName?scope.row.agentName:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="registrantUserName" width="150" label="注册备案人" :show-overflow-tooltip="true"></el-table-column>  
        <el-table-column prop="minUnit" width="100" label="最小单位"></el-table-column>
              <el-table-column prop="medicalInsuranceCategoryNo" width="140" label="医保代码" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="medicalInsuranceCategoryLongNo" width="140" label="医保代码(27位)" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="remark" show-overflow-tooltip label="备注">
          <template slot-scope="scope">
            {{ scope.row.remark?scope.row.remark:'-' }}
          </template>
        </el-table-column>

        <el-table-column prop="operation" fixed="right" label="操作" width="110">
          <template slot-scope="scope">
            <el-button v-if="tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick @click="handleUpdate(scope.row)" class="color-blue">查看</el-button>
            <el-button v-if="tableAcl.indexOf('Remove') != -1" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
          </template>
        </el-table-column>

      </el-table>
    </div>
 
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
    <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
  </div>
</template>

<script>
import {
  GetSupplierProductUpdates,
  RemoveSupplierProductUpdate,
  ApproveSupplierProductUpdates,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
// import SelectTree from '@/components/select-tree'
import {
  ApproveStateOptions
} from "@/enum";
import SelectFilter from "@/components/table-select-filter";
import BatchApproval from "@/components/batchApproval";
export default {
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    // SelectTree
    SelectFilter,
    BatchApproval
  },
  data () {
    return {
      batchApproval:ApproveSupplierProductUpdates,
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        states: [0],
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 弹出框标题
      title: "",
      // 弹出编辑框
      open: false,
      // 新增、编辑的数据
      form: {},
      // 多选框数据
      ids: [],
      multipleSelection: [],
      // 列表多选
      multiple: true,
      ApproveStateOptions: ApproveStateOptions,
      certApproveVisible: false,
      deptProductVisible: false,
      deptProductEditRules: {
        warehouseId: [{
          required: true,
          message: "请选择一级库房",
          trigger: "blur"
        }],
        deptIds: [{
          required: true,
          message: "请选择科室",
          trigger: "blur"
        }],
      },
      deptProductForm: {},
      filterOptions: [{
        name: "供货商产品",
        type: "select",
        code: "supplierProductId",
        filterMethod: this.getSupplierProductsNoDebounce,
        data: [],
      },
      {
        name: "供应商产品编码",
        type: "input",
        code: "supplierProductNo",
      },
      {
        name: "产品名称",
        type: "input",
        code: "productName",
      },
      {
        name: "规格型号",
        type: "input",
        code: "specName",
      },
      {
        name: "生产厂家",
        type: "input",
        code: "manufacturerName",
      },
      {
        name: "供应商",
        type: "input",
        code: "supplierName",
      },
      {
        name: "审批状态",
        type: "select",
        code: "states",
        data: ApproveStateOptions,
        multiple: true,
      },
      {
        name: "创建日期",
        type: "date",
        code: "date",
      },
      {
        name: "采购价",
        type: "numberRange",
        startCode: "minPurchasePrice",
        endCode: "maxPurchasePrice",
      }, {
        name: "商品代码",
        type: "input",
        code: "productCode",
      },
      {
        name: "产品id",
        type: "input",
        code: "newProductId",
      }, {
        name: "注册证号",
        type: "input",
        code: "productRegistCertNo",
      },
      ],
    };
  },
  computed: {
    system_setting () {
      return this.$store.getters.system_setting;
    },
  },
  methods: {
    handleSelectionChange (selection) {
      this.multipleSelection = selection;
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;
    },
    // 获取列表
    getData () {
      GetSupplierProductUpdates(this.query)
        .then((res) => {
          this.tableData = res.returnData.data;
          this.total = res.returnData.totalCount;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 查看信息
    handleInfo (row) {
      // this.$router.push("/supplier-product-update-edit?formMode=0&id=" + row.id);
      this.routePushWithParams("/supplier-product-update-edit", this.query, {
        formMode: 0,
        id: row.id,
      });
    },
    // 新建
    handleAdd () {
      // this.$router.push("/supplier-product-update-edit?formMode=1");
      this.routePushWithParams("/supplier-product-update-edit", this.query, {
        formMode: 1,
      });
    },
    // 编辑
    handleUpdate (row) {
      let binding = row.certApproveStateName !== '未绑定' ? true : false
      // this.$router.push("/supplier-product-update-edit?formMode=0&id=" + row.id);
      this.routePushWithParams("/supplier-product-update-edit", this.query, {
        formMode: 0,
        id: row.id,
        binding
      });
    },

    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.loading = true;
      this.getData();
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.loading = true;
      this.getData();
    },

    // 删除部门
    handleDelete (row) {
      const ids = row && row.id ? [row.id] : this.ids;

      this.$my_confirm("此操作将删除数据, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          return RemoveSupplierProductUpdate({
            ids
          });
        })
        .then(() => {
          this.$my_message(`删除成功`, "success");
          this.getData();
        })
        .catch(() => { });
    },
    // 重置
    reset () {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.ids = [];
      this.multipleSelection = [];
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection();
      }
      this.loading = true;
      this.getData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.loading = true;
      this.getData();
    },
    filterChange (query) {
      window.console.log(query);
      this.query = Object.assign(this.query, query);
      this.getData();
    },

    handleApprove () {
      if (this.ids.length == 0) {
        this.$my_message("请选中要审批通过的数据！", "warning");
        return;
      }

      // 校验数据状态
      let errorDatas = this.multipleSelection.filter((e) => e.state != 0);
      if (errorDatas && errorDatas.length > 0) {
        this.$my_message("请选择未审批的数据！", "warning");
        return;
      }

      const ids = this.ids;
      this.$my_confirm("确定要审批通过这些数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         this.ApproveSupplierProductUpdate(ids,0)
        })
       
    },
    // ApproveSupplierProductUpdate(ids,i){
    //   if(i >= ids.length){
    //     this.$my_message(`审批成功`, "success");
    //     this.getData();
    //     return
    //   }
    //   ApproveSupplierProductUpdates({ids:[ids[i]]}).then(res=>{
    //     if( i !=ids.length){
    //       i ++
    //       this.ApproveSupplierProductUpdate(ids,i)
    //     }
    //   })
    //   },
  },
  created () {
    // 分页组件默认值需要早created
    // 注释查询会点不动，不注释问题在价格查询返回清空
    if (this.$route.params) {
      var maxPurchasePrice = this.$route.params.maxPurchasePrice;
      var minPurchasePrice = this.$route.params.minPurchasePrice
      this.query = this.$route.params;
      this.$nextTick(() => {
        this.$route.params.maxPurchasePrice = maxPurchasePrice
        this.$route.params.minPurchasePrice = minPurchasePrice
      })
    }
  },
  mounted () {
    // 查询组件默认值需要在mounted
    if (this.$route.params) {
      this.query = this.$route.params;
      this.$refs["selectFilter"].query = this.query;
    }
    if(this.$refs["selectFilter"].query.states.length==0){
      this.$refs["selectFilter"].query.states = [0];
    }
    this.getData();
    this.getDepts("");
    this.getOneLevelWarehouses("");
  },
};
</script>

<style lang="scss" scoped></style>
